<script>
    export default {
        name: "LoginMixin",
        data() {
            return {
                loginId: null,
                password: null,
            };
        },
        methods: {
            /**
             * 로그인 시도전 유효성 검증을 수행합니다. 성공시 로그인을 시도합니다.
             */
            onClickLogin() {
                if (!this.checkRule(this.RULES.loginId(this.loginId))) return;
                if (!this.checkRule(this.RULES.password(this.password))) return;
                this.login();
            },

            /**
             * 로그인 후 성공시 메인 페이지로 이동한다.
             */
            login() {
                this.userManager.login(this.loginId, this.password)
                    .then(() => {
                        this.$router.replace({path: "/"});
                    });
            },
        },
    }
</script>